import { createContext, ReactNode, useEffect, useState } from "react";

type UserType = {
  token: string;
  authTime: number;
  exp: number;
  name: string;
  email: string;
  setToken: (newState: string) => void;
  setAuthTime: (newState: number) => void;
  setExp: (newState: number) => void;
  setName: (newState: string) => void;
  setEmail: (newState: string) => void;
  isSessionValid: () => boolean;
};

const initialValue: UserType = {
  token: localStorage.getItem("token") || "",
  authTime: localStorage.getItem("authTime")
    ? Number(localStorage.getItem("authTime"))
    : 0,
  exp: localStorage.getItem("exp") ? Number(localStorage.getItem("exp")) : 0,
  name: localStorage.getItem("name") || "",
  email: localStorage.getItem("email") || "",
  setToken: () => {},
  setAuthTime: () => {},
  setExp: () => {},
  setName: () => {},
  setEmail: () => {},
  isSessionValid: () => false,
};

export const UserContext = createContext(initialValue);

type UserContextProps = {
  children: ReactNode;
};

export const UserContextProvider = ({ children }: UserContextProps) => {
  const [token, setToken] = useState(initialValue.token);
  const [authTime, setAuthTime] = useState(initialValue.authTime);
  const [exp, setExp] = useState(initialValue.exp);
  const [name, setName] = useState(initialValue.name);
  const [email, setEmail] = useState(initialValue.email);

  useEffect(() => {
    localStorage.setItem("token", token);
    localStorage.setItem("authTime", `${authTime}`);
    localStorage.setItem("exp", `${exp}`);
    localStorage.setItem("name", name);
    localStorage.setItem("email", email);
  }, [token, authTime, exp, name, email]);

  return (
    <UserContext.Provider
      value={{
        token,
        authTime,
        exp,
        name,
        email,
        setToken,
        setAuthTime,
        setExp,
        setName,
        setEmail,
        isSessionValid: () => {
          const timestamp = new Date().getTime();
          const diff = exp - timestamp;
          return diff > 0;
        },
      }}
    >
      {children}
    </UserContext.Provider>
  );
};